/* Exercise verdicts are announced from here rather than from the feedback
   paragraph inside the exercise: that paragraph is inserted and replaced on
   every answer, and a live region that is a brand-new node each time is
   announced unreliably. This one is always in the document. */
import { useApp } from '../state/AppProvider';

export function LiveRegion() {
  const { live } = useApp();
  return (
    <div className="sr-live" id="ex-live" role="status" aria-live="polite">
      {live}
    </div>
  );
}
